export default __webpack_public_path__ + "static/media/PowellCatLocation-13.7dc5e183.jpg";